class MembershipTerms {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.checkboxes = element.querySelectorAll('input[type="checkbox"]') ?? [];
    this.submitButton = element.querySelector('button[type="submit"]');
    this.init();
  }

  init() {
    this.checkboxes.forEach((radio, i) => {
      radio.addEventListener('change', (e) => {
        this.maybeUpdateButtonStatus();
      });
    });

    this.maybeUpdateButtonStatus();
  }

  maybeUpdateButtonStatus() {
    if (this.submitButton) {
      this.submitButton.disabled = !this.allChecked();
    }
  }

  allChecked() {
    return Array.from(this.checkboxes).every((radio) => radio.checked);
  }
}

export default MembershipTerms;
